<template>
  <v-dialog
    v-model="show"
    light
    persistent
    :hide-overlay="hideOverlay"
  >
    <v-card>
      <v-card-title
        class="headline"
        :class="danger ? 'error white--text' : ''"
      >
        <v-icon
          v-show="danger"
          class="mr-3 white--text"
        >
          {{ IconEnum.warning }}
        </v-icon>
        {{ title }}
      </v-card-title>

      <v-card-text
        v-if="content"
        class="pt-3"
      >
        {{ content }}
      </v-card-text>

      <slot v-else />

      <v-card-actions>
        <v-btn
          v-if="useBtnCancel"
          :text="flat"
          :outlined="outlined"
          color="error"
          class="btn"
          @click="$emit('hide')"
        >
          {{ btnCancel }}
        </v-btn>
        <v-spacer />
        <v-btn
          :text="flat"
          :outlined="outlined"
          :disabled="validDisabled"
          color="success"
          class="btn"
          @click="$emit('validate')"
        >
          {{ btnValidate }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { IconEnum } from '@/modules/Enums'

export default {
  name: 'Dialog',

  model: {
    prop: 'show',
    event: 'change'
  },

  props: {
    show: { type: Boolean, default: false },
    //
    title: { type: String, default: '' },
    content: { type: String, default: null },
    flat: { type: Boolean, default: false },
    outlined: { type: Boolean, default: false },
    hideOverlay: { type: Boolean, default: false },
    danger: { type: Boolean, default: false },
    validDisabled: { type: Boolean, default: false },
    btnValidate: { type: String, default: 'Valider' },
    btnCancel: { type: String, default: 'Annuler' },
    useBtnCancel: { type: Boolean, default: true }
  },

  data () {
    return {
      IconEnum
    }
  }
}
</script>
